import React from "react";

class VehicleTitleBox extends React.Component {
  render() {
    const { title, children } = this.props;

    return (
      <div style={{ position: "relative", marginTop: "24px", width: "97%" }}>
        <span
          style={{
            position: "absolute",
            top: "-12px",
            left: "16px",
            background: "#fff",
            padding: "0 8px",
            fontWeight: "500",
            fontSize: "16px",
            zIndex: 1,
          }}
        >
          {title}
        </span>
        <div
          style={{
            border: "1px solid #d9d9d9",
            borderRadius: "8px",
            padding: "16px 16px 16px 16px",
            background: "#fff",
          }}
        >
          {children}
        </div>
      </div>
    );
  }
}

export default VehicleTitleBox;
